import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';

export type DeleteRoutingFilterButtonProps = Readonly<{
  onClick: () => void;
  disabled?: boolean;
}>;

export function DeleteRoutingFilterButton(props: DeleteRoutingFilterButtonProps) {
  return (
    <ButtonWidget
      testId="delete-routing-filter-button"
      buttonType={ButtonType.Icon}
      onClick={props.onClick}
      title={Messages.bridgeSiteSettingsDeleteRoutingFilter()}
      aria-label={Messages.bridgeSiteSettingsDeleteRoutingFilter()}
      disabled={props.disabled}
    >
      <img src={imgPath('trash_14px_small.svg')} aria-hidden={true} alt={''} />
    </ButtonWidget>
  );
}
